import React from 'react';
import PropTypes from 'prop-types';
import { AnimatedElement } from '../../animated-element';
import { Container } from '../styles/imageOnly.style';

const propTypes = {
  image: PropTypes.object,
};

const defaultProps = {
  image: {
    file: {},
  },
};

/**
 * Component that  counts down to a date specified in the config/**
 * Hero Component
 * @param {object} params Incoming Params
 * @returns {XML} A new copyright component
 */
const ImageDivider = ({
  image: {
    file: {
      url,
      details: {
        image: { height, width },
      },
    },
  },
}) => (
  <AnimatedElement data={{ image: { file: { url } } }} animationType="PARALLAX">
    <Container background={url} height={(height / width) * 100} />
  </AnimatedElement>
);

ImageDivider.propTypes = propTypes;
ImageDivider.defaultProps = defaultProps;

export default ImageDivider;



// WEBPACK FOOTER //
// ./src/components/dividers/components/imageOnly.js